import { Features, useFeatureFlags } from '@/shared/ui';
import { useNavigationVersion } from '../../model/useNavigationVersion';
import { NavigationDrawerV1 } from '../NavigationDrawerV1/NavigationDrawerV1';
import { NavigationDrawerV2 } from '../NavigationDrawerV2';

export function NavigationDrawer() {
  const { isFeatureAvailable } = useFeatureFlags();
  const { version } = useNavigationVersion();

  if (version === 'v2' || isFeatureAvailable(Features.navigationV2)) {
    return <NavigationDrawerV2 />;
  }

  return <NavigationDrawerV1 />;
}
